import { Experiences } from "@/getServerSideProps/monetate/getExperiences/experiencesSchema";
import { encodeExperiencesObject } from "@/utils/monetate/encodeExperiencesObject";
import Script from "next/script";

type Props = {
  productId: string;
  reviewsApiKey: string;
  reviewsScriptUrl: string;
  productUrl?: string;
  numberOfReviews: number | undefined;
  media: string;
  experiencesRawObject: Experiences;
};

const height = {
  meta: 440,
  review: 140,
  noReviews: 100,
};
const REVIEWS_PER_PAGE = 5;

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace React.JSX {
    export interface IntrinsicElements {
      "jl-reviews": {
        "data-testid"?: string;
        productId: string;
        apiKey: string;
        clientId: string;
        modalRootId: string;
        displayTitle: string;
        accordion: string;
        reviewSummary?: {
          averageRating: number;
          numberOfReviews: number;
        };
        productUrl?: string;
        media?: string;
        experiments?: string;
      };
    }
  }
}

export const ReviewsUI = ({
  productId,
  reviewsApiKey,
  reviewsScriptUrl,
  productUrl,
  numberOfReviews,
  media,
  experiencesRawObject,
}: Props) => {
  const minHeight =
    numberOfReviews && numberOfReviews > 0
      ? `${
          height.meta +
          height.review * Math.min(numberOfReviews, REVIEWS_PER_PAGE)
        }px`
      : `${height.noReviews}px`;

  return (
    <div
      id="ratings-reviews-section"
      style={{ minHeight }}
      data-component="Reviews"
    >
      <Script
        data-testid={"product-reviews-script"}
        type={"text/javascript"}
        src={reviewsScriptUrl}
        defer
      />
      <jl-reviews
        data-testid={"product-reviews"}
        productId={productId}
        apiKey={reviewsApiKey}
        clientId={"web-pdp-scaffold-ui"}
        modalRootId={"page-root"}
        displayTitle={"true"}
        accordion={"false"}
        productUrl={productUrl}
        media={media}
        experiments={encodeExperiencesObject(experiencesRawObject)}
        data-hj-allow-iframe=""
      />
    </div>
  );
};
